import React, { Component } from 'react';
import { withRouter, Link } from 'react-router-dom';

//HELPERS
import * as c from '../../helpers/constants'
import { callApi } from '../../helpers/methods'

//REDUX
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

//COMPONENTS
import {Row, Column, IBox, Title, Content, Button, CheckBox, Icon, Return, Select} from '../inspinia';
import Pagination from "react-js-pagination";
import { configAction } from '../../store/configUsuario';
import SelectMultiSelect from 'react-select';
import { ROLE_ADMINISTRADOR, ROLE_SIMPLES } from '../../store/roles';

import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import { CircularProgress } from '@material-ui/core';


class Usuario extends React.Component {
    
    constructor(props)
    {
        super(props);    
        
        this.state = 
        {
            selectedOption: null,
            loading: false,
            pageInit: 0,
            idUsuario: this.props.auth.user.id,
            searchButtonDisabled: true,
            searchButtonClicked: false,
            
            form: this.formInitialState(),
            list: 
            {
                currentPage: 0, pageCount: 0, pageSize: 0, rowCount: 0, results: undefined
            },
            comboFiltro: 
            {
                results: undefined
            },
            comboPapel: 
            {
                results: undefined
            },
            comboEmpresa: [],
            podeEditarFormulario: this.props.auth.user.papel[0] === ROLE_SIMPLES,
            alerta: withReactContent(Swal)
            
        }

        this.handleChange           = this.handleChange.bind(this);
        this.handleAdicionarUsuario = this.handleAdicionarUsuario.bind(this);
        this.handlePageChange       = this.handlePageChange.bind(this);
        this.handleLimparPesquisa   = this.handleLimparPesquisa.bind(this);
        this.handleChangeSelectMulti = this.handleChangeSelectMulti.bind(this);
        this.handleGerarNovaSenha = this.handleGerarNovaSenha.bind(this);
        this.handleResetSenha = this.handleResetSenha.bind(this);
        this.handlePesquisarUsuario = this.handlePesquisarUsuario.bind(this);

    }


    formInitialState () 
    {
        return {
            usuarioFiltro: "",
            tipoFiltro: "",
            id: "",
            usuario: "",
            nome: "",
            email: "",
            papel: "",
            empresa: null,
            primeiroAcesso: false
        }
    }

    componentDidMount() {      
        this.LoadTable();
        this.LoadPapeis();
        this.LoadComboEmpresa();
        this.LoadComboFiltro();
    }

    handleChange(e) {
        const form = this.state.form;

        this.setState({ form: { ...form, [e.target.name]: e.target.value } });
    }

    handleChangeSelectMulti(selectedOption) {

        const form = this.state.form;

        this.setState({ form: { ...form, empresa: selectedOption } });

    }

    handlePageChange(pageNumber) {
        this.state.page = pageNumber;
        if (this.state.searchButtonClicked) {
            this.LoadTable(
                pageNumber,
                this.state.form.usuarioFiltro,
                this.state.form.tipoFiltro
            );
        }
        else {
            this.LoadTable(pageNumber);
        }
    }

    handleAdicionarUsuario() {
        this.LoadAdicionarUsuario();       
    }

    handleMensagemSucesso()
    {
        c.TOASTER_SUCCESS(`Usuário ${this.state.form.nome} cadastrado com sucesso!`);  
    }


    handleLimparPesquisa()
    {
        this.state.list = [];
        this.state.form.id = "";
        this.state.form.usuario = "";
        this.state.form.nome = "",
        this.state.form.email = "",
        this.state.form.papel = "",
        this.state.form.empresa = null,
        this.LoadTable(this.state.page);
    }

    LoadComboFiltro() {
        let self = this;
    
        const url = `${c.API_BASE_URL}/users-filter`;
        const options = 
        {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' }
        };
    
        self.setState({ ...self.state, loading: true });
    
        callApi(url, options, function (response) {
            self.setState({ ...self.state, loading: false, comboFiltro: response });
        });
    }
    

    LoadComboEmpresa() {
        let self = this;
        const data = JSON.stringify({
            'id_produto': null
        });
        let url = '';
        let options ={};
        if(self.props.auth.user.papel[0] === ROLE_ADMINISTRADOR){
            url = `${c.API_BASE_URL}/company`;

            options = {
                method: 'GET'
                ,headers: { 'Content-Type': 'application/json' }
            };
        } else {
            url = `${c.API_BASE_URL}/company-user`;

            options ={
                method: 'POST'
                ,headers: { 'Content-Type': 'application/json' }
                ,body: data 
            };
        }
        self.setState({ ...self.state, loading: true })

        callApi(url, options, function (response) {
            self.setState({ ...self.state, loading: false, comboEmpresa: response.results });
        });
    }

    LoadPapeis() {
       
        let self = this;

        const url = `${ c.API_BASE_URL }/papers`;
        const options =
        {
            method: 'GET'
            ,headers: { 'Content-Type': 'application/json' }
        };
    
        self.setState({...self.state, loading: true})

        callApi(url, options, function(response)
        {         
            let listaPapeis = response
            let papelUsuario = self.props.auth.user.papel[0];
    
            if(papelUsuario !== ROLE_ADMINISTRADOR && listaPapeis.results !== undefined) {
                listaPapeis = listaPapeis.results.filter( el => el.label !== "ADMINISTRADOR");            
                listaPapeis.results = listaPapeis;
            }

            self.setState({...self.state, loading: false, comboPapel: listaPapeis});

        });

    }

    isValidFilter(filter) {
        return filter !== "Selecione..." && filter !== "Filtros";
    }

    handlePesquisarUsuario() {

        if (this.state.loading) {
            return;
        }

        const user = this.state.form.usuarioFiltro;
        let filter = this.state.form.tipoFiltro;

        if (!this.isValidFilter(filter)) {
            filter = "";
        }

        if (!user && !filter) {
            this.LoadTable(1);
            return;
        }
    
        if (!user) {
            c.TOASTER_INFO('Para realizar essa pesquisa é necessário informar o campo "Usuario" !');
            return;
        }
    
        if (!filter) {
            c.TOASTER_INFO('Para realizar essa pesquisa é necessário informar o campo "Filtro" !');
            return;
        }

        this.setState({ ...this.state, loading: true, searchButtonDisabled: true, searchButtonClicked: true, page: 1 }, this.LoadTable(0, user, filter));
    }

    
    LoadTable(pageNumber, user, filter) {
        let page = (pageNumber === undefined || pageNumber === 0) ? 0 : --pageNumber;
    
        let filterValid = filter === "Selecione..." ? "" : filter;
    
        const url = `${c.API_BASE_URL}/researchUsers`;
        const options = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                page: page,
                user: user,
                filter: filterValid
            })
        };
    
        this.setState({ ...this.state, loading: true, searchButtonDisabled: true });
    
        callApi(url, options, (response) => {
            this.setState({ ...this.state, loading: false, list: response, searchButtonDisabled: false });
        });
    }
    

    LoadAdicionarUsuario()
    {
        let self = this;

        const url = `${ c.API_BASE_URL }/users`;
        const options =
        {
            method: 'POST' 
            ,headers: { 'Content-Type': 'application/json' }
            ,body: JSON.stringify({            
                nome: this.state.form.nome,
                email: this.state.form.email,
                ativo: true,
                papel: this.state.form.papel,
                empresas: this.state.form.empresa
            })
        };
    
        self.setState({...self.state, loading: true})

        callApi(url, options, function(response)
        { 
            self.setState({ ...self.state, page: 0 }, self.handleLimparPesquisa(), self.handleMensagemSucesso());      
        });
    }

    handleResetSenha(nome) {
        const self = this;

        self.state.alerta.fire({
            title: 'Realmente deseja resetar a senha do usuário ' + nome + '?',
            text: 'Essa ação é irreversível!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sim',
            cancelButtonText: 'Cancelar',
            confirmButtonColor: '#47A789',
            cancelButtonColor: '#ED5358',
            reverseButtons: true,
            preConfirm: () => {
                return this.handleGerarNovaSenha();
            },
            allowOutsideClick: () => !this.state.alerta.isLoading(),
            showLoaderOnConfirm: true,
            backdrop: true,
        }).then((result) => {
            if (result.isConfirmed) {
                this.state.alerta.fire({
                    title: 'Reset de Senha',
                    text: `Uma nova senha será enviada para o usuário ${nome}`,
                    icon: 'success',
                    confirmButtonColor: '#47A789'
                })
            } else if (
                result.dismiss === Swal.DismissReason.cancel
            ) {
                this.state.alerta.fire({
                    title: 'Cancelado',
                    text: 'Reset de senha não realizado!',
                    icon: 'error',
                    confirmButtonColor: '#47A789'
                })
            }
        });
    }

    handleGerarNovaSenha() {
        let self = this;

        const url = `${c.API_BASE_URL}/users/reset-senha`;
        const options =
        {
            method: 'POST' 
            ,headers: { 'Content-Type': 'application/json' }
            , body: JSON.stringify({
                id: self.state.form.id,
                papel: this.state.form.papel,
                empresas: this.state.form.empresa
            })
        };

        self.setState({...self.state, loading: true})

        callApi(url, options, function(response)
        { 
            self.setState(self.handleLimparPesquisa(), self.handleMensagemSucesso());      
        });
    }

    render() {

        const form = this.state.form;        

        return (                     
            <div>
                {/* MAIN CONTENT */}
                <Row className="mb-5">
                    <Column size="7">
                        <IBox>
                            <Title>
                                <h3 className="text-slate-grey">Usuários da plataforma</h3>
                            </Title>
    
                            <Content>
                            <Row className="form-row">
                                    <div className="form-group col-md-5">
                                        <label>Usuario:</label>     
                                        <input type="text" name="usuarioFiltro" value={form.usuarioFiltro} onChange={this.handleChange} className="form-control"  />
                                    </div>

                                    <div className="form-group col-md-4">
                                        <label>Filtros:</label>
                                        <Select name="tipoFiltro" selected={form.tipoFiltro} data={this.state.comboFiltro} onChange={this.handleChange} placeholder="Filtros"  />
                                    </div>
                                    
                                    <div className="form-group col-md-1" style={{marginTop:'28px', marginLeft:"5px"}}>
                                        <Button onClick={this.handlePesquisarUsuario} disabled={this.state.searchButtonDisabled}> 
                                        <Icon name="far fa-search"/> Pesquisar</Button>
                                        {this.state.loading && <CircularProgress size={20} className="ml-2" />}
                                    </div>
                                    
                            </Row>

                                {/* TABELA */}
                                <Row className="m-0 mb-0">
                                    <Column className="p-0 table-responsive">
                                        <Table data={this.state.list} history={this}/>                                        
                                    </Column>
                                </Row>
                            </Content>
                        </IBox>


                        {/* FOOTER */}  
                        <Row className="mb-5">
                            <Column className="container">
                                <Row>
                                    <Column size="12" className="text-center">
                                        <div className="d-flex justify-content-center">                 
                                            
                                            <Pagination
                                                hideNavigation
                                                pageRangeDisplayed={c.DEFAULT_PAGE_RANGE}
                                                activePage={this.state.page}
                                                itemsCountPerPage={this.state.list.pageSize}
                                                totalItemsCount={this.state.list.rowCount}
                                                onChange={this.handlePageChange}
                                            />

                                        </div>
                                    </Column>  
                                </Row>
                            </Column>
                        </Row>                        
                    </Column>


                    <Column size="5">
                        <IBox>
                            <Title>
                                <h3 className="text-slate-grey">Novo Usuário</h3>
                            </Title>                            
                        
                            <Content>

                                <Row className="form-row">
                                    <div className="form-group col-md-12">
                                        <input type="text" name="nome" value={form.nome} onChange={this.handleChange} className="form-control" placeholder="Nome" readOnly={this.state.podeEditarFormulario} /> 
                                    </div>
                                </Row>

                                <Row className="form-row">
                                    <div className="form-group col-md-12">
                                        <input type="email" name="email" value={form.email} onChange={this.handleChange} className="form-control" placeholder="E-mail" readOnly={this.state.podeEditarFormulario}/>     
                                    </div>
                                </Row>

                                <Row className="form-row">
                                    <div className="form-group col-md-12">
                                        <Select name="papel" selected={form.papel} data={this.state.comboPapel} onChange={this.handleChange} placeholder="Papel" disabled={this.state.podeEditarFormulario}/>
                                    </div>
                                </Row> 

                                <Row className="form-row">
                                    <div className="form-group col-md-12" disabled="true"> 
                                        <SelectMultiSelect 
                                            value={form.empresa} 
                                            onChange={this.handleChangeSelectMulti} 
                                            options={this.state.comboEmpresa} 
                                            isMulti='true' 
                                            placeholder='Selecione uma empresa ou várias empresas' isDisabled={this.state.podeEditarFormulario}/>
                                    </div>
                                </Row>  

                                <Row className="form-row">
                                    <div className="form-group col-md-4">
                                        <Button onClick={this.handleAdicionarUsuario}><Icon name="fa-save"/>Salvar</Button>
                                    </div>
                                    <div className="form-group col-md-5">
                                        <Button disabled={form.id === ""} onClick={() => this.handleResetSenha(form.nome)}><Icon name="fa-refresh"/>Reset Senha</Button>
                                    </div>
                                    <div className="form-group ml-6">
                                        <Button onClick={this.handleLimparPesquisa}><Icon name="far fa-trash"/>Limpar</Button>
                                    </div>
                                </Row>

                            </Content>
                        </IBox>
                    </Column>

                </Row>

            </div>
        );
    }


}

class Table extends React.Component
{
    constructor(props)
    {
        super(props);
        this.state = 
        {
            selfUsuario: props.history,
        }
        

        this.ativarClick   = this.ativarClick.bind(this);
        this.excluirClick  = this.excluirClick.bind(this);
        this.editarClick   = this.editarClick.bind(this);
    }

    editarClick(id, usuario) {
        let mainContext = this.state.selfUsuario;
        let idLogado = mainContext.props.auth.user.id;
        let form = mainContext.state.form;

        if (parseInt(id) === 0) return;

        mainContext.setState({
            form: {
                ...form,
            id: id,
            nome: usuario.nomeUsuario, 
            email: usuario.email,
            papel: usuario.idPapel,
            empresa: usuario.empresas.results,
            primeiroAcesso: usuario.primeiroAcesso
        }});

    }

    ativarClick(id, situacao)
    {
        let mainContext = this.state.selfUsuario;
        let idLogado = mainContext.props.auth.user.id;

        if (parseInt(id) === 0) return;

        if (parseInt(id) === parseInt(idLogado)){
            c.TOASTER_INFO(`Usuário não pode ser ativo/desativado`);  

        } else {
            this.LoadAtivar(id, situacao);          

        }


    }

    excluirClick(id)
    {

        let mainContext = this.state.selfUsuario;
        let idLogado = mainContext.props.auth.user.id;

        if (parseInt(id) === 0) return;

        if (parseInt(id) === parseInt(idLogado)){
            c.TOASTER_INFO(`Usuário não pode ser removido`);  

        } else {            
            this.LoadExcluir(id);
             
        }


    }

    statusEnvio(status){
        if (status == "SIMPLES" || status == "SIMPLES_RASTREADO"){
            return( <span style={{color:"#009966"}}>Rastreado</span>)
        }
        else if (status == "SIMPLES_RASTREADO_VERIFICAR"){
            return( <span style={{color:"#00CED1"}}>Rastreado e Verifica</span>)
        }
    }

    situacaoUsuario(status){
        if (status == true){
            return( <span style={{color:"#0000CD"}}>Ativo</span>)
        }
        else if (status == false){
            return( <span style={{color:"#FF0000"}}>Desativado</span>)
        }
    }

    LoadExcluir(id)
    {
        
        let mainContext = this.state.selfUsuario;

        const url = `${ c.API_BASE_URL }/users/${ id }`;
        const options =
        {
            method: 'DELETE'
            ,headers: { 'Content-Type': 'application/json' }
        };
    
        this.setState({...this.state, loading: true})

        callApi(url, options, function(response)
        { 
            if(response.status === 'OK') {
                mainContext.setState({ ...mainContext.state, page: 0 }, mainContext.handleLimparPesquisa()); 
                c.TOASTER_SUCCESS(`Usuário removido com sucesso!`);   
            }
                 
        });
    }

    LoadAtivar(id, situacao)
    {
        
        let mainContext = this.state.selfUsuario;
        let ativarDesativar = !situacao;
        
        const url = `${ c.API_BASE_URL }/users-ativar/${ id }`;
        const options =
        {
            method: 'PUT'
            ,headers: { 'Content-Type': 'application/json' }
            ,body: JSON.stringify({
                ativo: ativarDesativar
            })
        };
    
        this.setState({...this.state, loading: true})

        callApi(url, options, function(response)
        { 
            if(response.id !== null) {
                mainContext.setState({ ...mainContext.state, page: 0 }, mainContext.handleLimparPesquisa());     
                c.TOASTER_SUCCESS(`Usuário ${situacao === true ? 'desativado' : 'ativado'} com sucesso!`);   
            }
             
        });

    }


    render()
    {    
        const data = this.props.data; 
        let html = "";

        if (data.results === undefined)
        {
            html = (<tr><td colSpan="7" scope="row">Carregando...</td></tr>);
        }
        else if (data.results.length === 0)
        {
            html = (<tr><td colSpan="7" scope="row">Nenhum registro encontrado.</td></tr>);
        }
        else if (data.results.length   > 0)
        {
            html = data.results.map(row =>
                <tr key={row.id} id={row.id}>
                    <td>{row.id}</td>
                    <td>{row.nomeUsuario}</td>
                    <td>{this.statusEnvio(row.permissao)}</td>
                    <td>{this.situacaoUsuario(row.ativo)}</td>                               
                    <td className="text-center">
                        <a onClick={() => this.editarClick(row.id, row)}><Icon name="fa-pencil" className="mx-1 text-muted"/></a>
                        <a onClick={() => this.ativarClick(row.id, row.ativo)}><Icon name="fa fa-power-off" className="mx-1 text-success"/></a>
                        <a onClick={() => this.excluirClick(row.id)}><Icon name="fa-times" className="mx-1 text-muted"/></a>
                    </td>
                </tr>                  
            );
        }

        return(
            <table className="footable table table-striped toggle-arrow-tiny text-body">
                <thead>
                    <tr style={{backgroundColor: "#dbf1e9"}}>       
                        <th>#</th>
                        <th>Usuário</th>
                        <th>Permissão de envio</th>
                        <th>Situação</th>
                        <th className="text-center">Ações</th>
                    </tr>
                </thead>

                <tbody>{html}</tbody>
            </table>
        )
    }
}


function mapStateToProps(state)
{
    return { auth: state.auth, config: state.config };
}
function mapDispatchToProps(dispatch)
{
    return { actions: { config: bindActionCreators(configAction, dispatch) } };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Usuario));

